module.exports = __webpack_public_path__ + "static/media/86 - sir Was - Deployed (feat. Little Dragon).bdaeda4d.mp3";